import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneOrMobileValidator(): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const phone = formGroup.get('phone');
    const mobile = formGroup.get('mobile');

    const isValid = !!(phone?.value || mobile?.value);

    if (!isValid) {
      // Fehler setzen für die Gruppe
      formGroup.setErrors({ phoneOrMobileRequired: true });

      // Fehler auf die einzelnen Felder anwenden
      if (phone) {
        phone.setErrors({ required: true });
      }
      if (mobile) {
        mobile.setErrors({ required: true });
      }
    } else {
      // Einzelne Feldfehler zurücksetzen, wenn das Formular jetzt gültig ist
      if (phone && phone.hasError('required')) {
        phone.setErrors(null);
      }
      if (mobile && mobile.hasError('required')) {
        mobile.setErrors(null);
      }
      formGroup.setErrors(null); // Entferne Gruppenfehler
    }

    return isValid ? null : { phoneOrMobileRequired: true };
  };
}

export function extractErrorDetail(error: any): string {
  try {
    const messages: string[] = [];

    const collectMessages = (obj: any, path = '') => {
      if (typeof obj === 'string') {
        messages.push(`${path}: ${obj}`);
      } else if (Array.isArray(obj)) {
        obj.forEach((item, index) =>
          collectMessages(item, `${path}[${index}]`),
        );
      } else if (typeof obj === 'object' && obj !== null) {
        for (const key in obj) {
          if (key === 'trace' || key === 'exception' || key === 'file')
            continue;
          collectMessages(obj[key], path ? `${path}.${key}` : key);
        }
      }
    };

    collectMessages(error);

    return messages.length > 0 ? messages.join('\n') : 'Unbekannter Fehler';
  } catch (e) {
    return 'Fatal error - could not determine the error type';
  }
}

export function validatePassword(password: string): boolean {
  const regex1 =
    /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{10,})/;
  const regex2 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{10,})/;

  return regex1.test(password) || regex2.test(password);
}
